<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Kondisi Stok Barang</div>
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="30"
          :rowHover="true"
          :scrollable="true"
          :loading="loading"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3" style="margin-top: 2.2rem">
                <AutoComplete
                  class="p-col"
                  placeholder="Pilih Tahun"
                  :dropdown="true"
                  :suggestions="year_filtered"
                  v-model="year"
                  @complete="setYear($event)"
                >
                  <template #item="slotProps">
                    <div class="p-col">
                      <div>{{ slotProps.item }}</div>
                    </div>
                  </template>
                </AutoComplete>
              </div>
              <div class="p-col-3" style="margin-top: 2.7rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getApi()"
                />
              </div>
              <div class="p-col-3" style="margin-top: 2.7rem">
                <router-link
                  :to="{
                    name: 'print-items-condition',
                    query: {
                      year: year,
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    class="p-button-success"
                    icon="pi pi-print"
                  />
                </router-link>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>
          <Column
            header="Kelompok Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_name }}
              </div>
            </template>
          </Column>
          <Column
            :header="`Stok Barang Tahun ${year_name}`"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock | number }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: false,
      items: null,
      today: new Date().toISOString().split('T')[0],
      year: null,
      year_filtered: null,
      years: [],
      year_name: null
    }
  },
  mounted() {
    this.getAuthUser()
    this.getYears()
  },
  methods: {
    getAuthUser() {
      this.year = this.today.split('-')[0]
      this.year_name = this.year
      this.getApi()
    },

    getYears() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlet-inbound/listyear`)
        .then(response => {
          if (response.status === 200) {
            this.years = response.data.data.years
          }
        })
    },

    setYear(event) {
      this.year_filtered = this.years.filter(item => {
        return item.toString().startsWith(event.query.toString())
      })
    },

    getApi() {
      if (this.year == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Pilih tahun terlebih dahulu',
          life: 3000
        })
        return
      }

      this.loading = true
      this.year_name = this.year
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/report/stock-in-year?year=${this.year}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.items = response.data.data.category
          } else {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data',
              life: 3000
            })
          }
        })
    }
  }
}
</script>
